import cn from 'classnames';
import styles from './RangeFilter.module.scss';
import { useState, useEffect } from 'react';
import { MultiRangeSlider } from '@/atoms/MultiRangeSlider';
import { FilterRangeType, RangeFilterObjectType } from '@/types';
import { Counter } from '@/atoms/Counter';

type RangeFilterProps = {
  className?: string;
  filter: FilterRangeType;
  title?: string;
  onChange: (code: string, min: number, max: number) => void;
  values: RangeFilterObjectType;
};

export function RangeFilter({
  className,
  filter,
  title,
  onChange,
  values,
}: RangeFilterProps) {
  const initialValues = values[filter.code]?.values;
  const [chosenMin, setChosenMin] = useState(
    initialValues?.min ?? filter.values.min,
  );
  const [chosenMax, setChosenMax] = useState(
    initialValues?.max ?? filter.values.max,
  );
  const wrapperClassName = cn(styles.wrapper, className);

  useEffect(() => {
    if (initialValues) {
      setChosenMin(initialValues.min);
      setChosenMax(initialValues.max);
    } else {
      setChosenMin(filter.values.min);
      setChosenMax(filter.values.max);
    }
  }, [initialValues, filter.values.min, filter.values.max, filter.code]);

  const handleChangeMin = (value: number) => {
    setChosenMin(value);
    onChange(filter.code, value, chosenMax);
  };

  const handleChangeMax = (value: number) => {
    setChosenMax(value);
    onChange(filter.code, chosenMin, value);
  };

  const handleSliderChangeMin = (value: number) => {
    setChosenMin(value);
  };

  const handleSliderChangeMax = (value: number) => {
    setChosenMax(value);
  };

  const handleSliderFinalChange = () => {
    onChange(filter.code, chosenMin, chosenMax);
  };

  return (
    <div className={wrapperClassName}>
      {title && <span className={styles.title}>{title}</span>}
      <div className={styles.inputs}>
        <Counter
          min={filter.values.min}
          max={filter.values.max}
          value={chosenMin}
          onChange={handleChangeMin}
          label="от"
        />
        <Counter
          min={filter.values.min}
          max={filter.values.max}
          value={chosenMax}
          onChange={handleChangeMax}
          label="до"
        />
      </div>
      <MultiRangeSlider
        values={{
          min: filter.values.min,
          max: filter.values.max,
          chosenMax,
          chosenMin,
        }}
        onChangeMin={handleSliderChangeMin}
        onChangeMax={handleSliderChangeMax}
        onFinalChange={handleSliderFinalChange}
      />
    </div>
  );
}
